import Lang from 'lang.js';
import messages from '../constants/lang.json';

const locale =
  localStorage.getItem('lang') || (window.client && window.client.locale);

window.Lang = new Lang({ messages, locale });
